export const colors = {
	primary: {
		base: '#b3e5fc',
		light: '#e6ffff',
		dark: '#82b3c9',
		textOn: '#01579b',
	},
	secondary: {
		base: '#e1f5fe',
		light: '#ffffff',
		dark: '#afc2cb',
		textOn: '#01579b',
	},
}



// WEBPACK FOOTER //
// ./src/utils/styles.js